var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1415 28.1367C12.9528 28.3338 12.9528 28.6534 13.1415 28.8505C13.3302 29.0476 13.6362 29.0476 13.8249 28.8505L20.9992 21.3569L28.1751 28.8522C28.3638 29.0493 28.6698 29.0493 28.8585 28.8522C29.0472 28.6551 29.0472 28.3355 28.8585 28.1384L21.6825 20.6431L28.1751 13.8616C28.3638 13.6645 28.3638 13.3449 28.1751 13.1478C27.9864 12.9507 27.6805 12.9507 27.4918 13.1478L20.9992 19.9294L14.5082 13.1495C14.3195 12.9524 14.0136 12.9524 13.8249 13.1495C13.6362 13.3466 13.6362 13.6662 13.8249 13.8633L20.3159 20.6431L13.1415 28.1367Z",
    fill: "#070A0D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.3fac9966000716636a3041cf9da8b323.svg";
export { ForwardRef as ReactComponent };